import { render, staticRenderFns } from "./Mensa.vue?vue&type=template&id=b4c0129e"
import script from "./Mensa.vue?vue&type=script&lang=js"
export * from "./Mensa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports